export const ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_NAME = 'sportsfi_account_security_setup';
export const ACCOUNT_SECURITY_SETUP_INTENT_COOKIE_VALUE = 'required';
